import React from "react";
import MediaEventsCard from "./components/mediaEventsCard";
import DataLoader from "../../components/loader/dataLoader";
import "../../assets/css/adminPages/mediaEvent/style.scss";
import useMediasAndEvents from "../../hooks/admin/useMediasAndEvents";

const Index = () => {
  const { data, isLoading, handleAdd, handleDelete } = useMediasAndEvents();

  return (
    <section className="media-event-section">
      <div className="custom-container">
        <div className="content-section">
          <h1 className="page-title">Media & Events</h1>
          <div className="content-body">
            <div className="row">
              <div className="col-12 pb-4 text-right">
                <button onClick={handleAdd} className="add-btn">
                  Add Media & Event +
                </button>
              </div>
              <div className="col-12">{isLoading && <DataLoader />}</div>
              {data &&
                data.map((item) => (
                  <MediaEventsCard
                    key={item.id}
                    data={item}
                    handleDelete={handleDelete}
                  />
                ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Index;
